
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent } from '@/components/ui/card';
import AIAgents from './AIAgents';
import AgentInteractionTimeline from './AgentInteractionTimeline';
import { Brain, History } from 'lucide-react';

const AgenticAgentsWrapper: React.FC = () => {
  const [activeTab, setActiveTab] = useState('agents');

  return (
    <Card className="w-full">
      <CardContent className="p-6">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="mb-4 grid w-full grid-cols-2">
            <TabsTrigger value="agents" className="flex items-center gap-1">
              <Brain className="h-4 w-4" />
              Agents
            </TabsTrigger>
            <TabsTrigger value="timeline" className="flex items-center gap-1">
              <History className="h-4 w-4" />
              Interaction Timeline
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="agents" className="mt-0">
            <AIAgents />
          </TabsContent>
          
          <TabsContent value="timeline" className="mt-0">
            <AgentInteractionTimeline limit={50} />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default AgenticAgentsWrapper;
